// extracted by mini-css-extract-plugin
export default {"itemButton":"ExchangeSynchronization_itemButton__5o4ni"};